module.exports = __webpack_public_path__ + "img/SMS28500-L-min.80f78bec.png";